export function getTagsLink(page) {
  return `/tags${page ? `?page=${page}` : ''}`
}
